<template>
  <div class="block-error" :style="inputStyle">
    <div class="block-error-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    icon: {
      type: String,
      default: 'sign_prompt'
    }
  },
  computed: {
    inputStyle () {
      let style = ''
      if (this.icon) {
        style += `background-image: url('http://az.img.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_icon_${this.icon}.png');`
      }
      if (this.width) {
        style += `;width:${this.width}`
      }
      return style
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.block-error {
  height: 47px;
  display: inline-block;
  position: relative;
  background-color: color(var(--colorError) a(10%));

  background-position-x: calc(20px + 1px); /* 1px border */
  background-position-y: center;
  background-repeat: no-repeat;

  border-radius: var(--borderRadius1);

  & .block-error-container {
    position: absolute;
    left: calc(51px + 1px);
    top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/block/ErrorBlock.vue